import Vue from 'vue'
import Vuex from 'vuex'
import users from '../store/modules/users';
import app from "@/store/modules/app";
import VuexPersistence from 'vuex-persist'
import * as LocalForage from "localforage";
Vue.use(Vuex)

LocalForage.config({
  driver: LocalForage.INDEXEDDB,
  name: 'mrs'
});
const vuexLocal = new VuexPersistence({
  key: 'keyvaluepairs',
  storage: LocalForage,
  asyncStorage: true
})



export default new Vuex.Store({
  plugins: [vuexLocal.plugin],

  modules: {
    users,
    app
  }
})
